export default "__VITE_ASSET__BEcFzgs___"